import { render, staticRenderFns } from "./NavMainMobile.vue?vue&type=template&id=95f1253a&scoped=true&"
import script from "./NavMainMobile.vue?vue&type=script&lang=js&"
export * from "./NavMainMobile.vue?vue&type=script&lang=js&"
import style0 from "./NavMainMobile.vue?vue&type=style&index=0&id=95f1253a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95f1253a",
  null
  
)

export default component.exports